import React from 'react';

function Buttons() {
	return (
		<div>
			<div className="wraper container-fluid dashboard-container">
				<div className="container">
					{/* Start Input  */}
					<section className="p-5">
						<div className="row">
							<div className="col-md-12">
								<h5 className="my-5">Primary 40px </h5>
							</div>
							<div className="col-md-12">
								<div className="d-flex justify-content-around">
									<button className="button">Button</button>
									<button className="button">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12">
								<h6 className="my-3">
									Primary 36px (use <strong>.size36</strong> class)
								</h6>
								<div className="d-flex justify-content-around">
									<button className="button size36">Button</button>
									<button className="button size36">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button size36">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button size36">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button size36">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button size36">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button size36">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12">
								<h6 className="my-3">
									Primary 32px (use <strong>.size32</strong> class)
								</h6>
								<div className="d-flex justify-content-around">
									<button className="button size32">Button</button>
									<button className="button size32">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button size32">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button size32">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button size32">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button size32">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button size32">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12 mt-4">
								<div className="d-flex justify-content-around">
									<button className="button" disabled>
										Button
									</button>
									<button className="button" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button" disabled>
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button" disabled>
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<h5 className="my-5">Tertiary 40px </h5>
							</div>
							<div className="col-md-12">
								<div className="d-flex justify-content-around">
									<button className="button tertiary">Button</button>
									<button className="button tertiary">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button tertiary">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12">
								<h6 className="my-3">
									Tertiary 36px (use <strong>.size36</strong> class)
								</h6>
								<div className="d-flex justify-content-around">
									<button className="button tertiary size36">Button</button>
									<button className="button tertiary size36">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button tertiary size36">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary size36">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary size36">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary size36">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary size36">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12">
								<h6 className="my-3">
									Tertiary 32px (use <strong>.size32</strong> class)
								</h6>
								<div className="d-flex justify-content-around">
									<button className="button tertiary size32">Button</button>
									<button className="button tertiary size32">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button tertiary size32">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary size32">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary size32">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary size32">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary size32">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12 mt-4">
								<div className="d-flex justify-content-around">
									<button className="button tertiary" disabled>
										Button
									</button>
									<button className="button tertiary" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button tertiary" disabled>
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary" disabled>
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button tertiary" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<h5 className="my-3">Add new</h5>
								<div className="d-flex">
									<div className="button-add-new separate">
										<button className="button">
											<svg
												fill="none"
												height={24}
												viewBox="0 0 24 24"
												width={24}
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
													fill="white"
												/>
											</svg>
											<span className="ml-1">Add new</span>
											<span className="bar mx-1">|</span>
										</button>
										<div className="btn-group">
											<button
												aria-expanded="false"
												aria-haspopup="true"
												className="button dropdown-toggle dropdown-toggle-split"
												data-toggle="dropdown"
												type="button"
											>
												<svg
													fill="none"
													height={5}
													viewBox="0 0 8 5"
													width={8}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.71 1.71L3.3 4.3C3.69 4.69 4.32 4.69 4.71 4.3L7.3 1.71C7.93 1.08 7.48 0 6.59 0H1.41C0.52 0 0.08 1.08 0.71 1.71Z"
														fill="white"
													/>
												</svg>
											</button>
											<div className="dropdown-menu dropdown-menu-right shadow">
												<a className="dropdown-item" href="#">
													<i className="fas fa-user fa-sm fa-fw mr-1 text-gray-400" />
													Profile
												</a>
												<a className="dropdown-item" href="#">
													<i className="fas fa-cogs fa-sm fa-fw mr-1 text-gray-400" />
													Settings
												</a>
												<a className="dropdown-item" href="#">
													<i className="fas fa-list fa-sm fa-fw mr-1 text-gray-400" />
													Activity Log
												</a>
												<a
													className="dropdown-item"
													data-target="#logoutModal"
													data-toggle="modal"
													href="#"
												>
													<i className="fas fa-sign-out-alt fa-sm fa-fw mr-1 text-gray-400" />
													Logout
												</a>
											</div>
										</div>
									</div>
									<div className="button-add-new">
										<div className="btn-group">
											<button
												aria-expanded="false"
												aria-haspopup="true"
												className="button dropdown-toggle dropdown-toggle-split"
												data-toggle="dropdown"
												type="button"
											>
												<svg
													fill="none"
													height={24}
													viewBox="0 0 24 24"
													width={24}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
														fill="white"
													/>
												</svg>
												<span className="mr-2">Add new</span>
												<svg
													fill="none"
													height={5}
													viewBox="0 0 8 5"
													width={8}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.71 1.71L3.3 4.3C3.69 4.69 4.32 4.69 4.71 4.3L7.3 1.71C7.93 1.08 7.48 0 6.59 0H1.41C0.52 0 0.08 1.08 0.71 1.71Z"
														fill="white"
													/>
												</svg>
											</button>
											<div className="dropdown-menu dropdown-menu-right shadow">
												<a className="dropdown-item" href="#">
													<i className="fas fa-user fa-sm fa-fw mr-1 text-gray-400" />
													Profile
												</a>
												<a className="dropdown-item" href="#">
													<i className="fas fa-cogs fa-sm fa-fw mr-1 text-gray-400" />
													Settings
												</a>
												<a className="dropdown-item" href="#">
													<i className="fas fa-list fa-sm fa-fw mr-1 text-gray-400" />
													Activity Log
												</a>
												<a
													className="dropdown-item"
													data-target="#logoutModal"
													data-toggle="modal"
													href="#"
												>
													<i className="fas fa-sign-out-alt fa-sm fa-fw mr-1 text-gray-400" />
													Logout
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<h5 className="mt-5">Secondary 40px</h5>
								<p className="mb-3">
									Note: use <strong>.size36</strong> &amp; <strong>.size32</strong>
									class for diffrent size)
								</p>
							</div>
							<div className="col-md-12">
								<div className="d-flex justify-content-around">
									<button className="button secondary">Button</button>
									<button className="button secondary">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button secondary ">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button secondary">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button secondary">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button secondary">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button secondary">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12 mt-4">
								<div className="d-flex justify-content-around">
									<button className="button secondary" disabled>
										Button
									</button>
									<button className="button secondary" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button secondary" disabled>
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button secondary" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button secondary" disabled>
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button secondary" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button secondary" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<h5 className="mt-5">Outline 40px</h5>
								<p className="mb-3">
									Note: use <strong>.size36</strong> &amp; <strong>.size32</strong>
									class for diffrent size)
								</p>
							</div>
							<div className="col-md-12">
								<div className="d-flex justify-content-around">
									<button className="button outline">Button</button>
									<button className="button outline">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button outline">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button outline">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button outline">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button outline">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button outline">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12 mt-4">
								<div className="d-flex justify-content-around">
									<button className="button outline" disabled>
										Button
									</button>
									<button className="button outline" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button outline" disabled>
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button outline" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button outline" disabled>
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button outline" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button outline" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<h5 className="mt-5">Gray Outline 40px</h5>
								<p className="mb-3">
									Note: use <strong>.size36</strong> &amp; <strong>.size32</strong>
									class for diffrent size)
								</p>
							</div>
							<div className="col-md-12">
								<div className="d-flex justify-content-around">
									<button className="button gray-outline">Button</button>
									<button className="button gray-outline">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button gray-outline">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button gray-outline">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button gray-outline">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button gray-outline">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button gray-outline">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12 mt-4">
								<div className="d-flex justify-content-around">
									<button className="button gray-outline" disabled>
										Button
									</button>
									<button className="button gray-outline" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button gray-outline" disabled>
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button gray-outline" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button gray-outline" disabled>
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button gray-outline" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button gray-outline" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<h5 className="mt-5">Text 40px</h5>
								<p className="mb-3">
									Note: use <strong>.size36</strong> &amp; <strong>.size32</strong>
									class for diffrent size)
								</p>
							</div>
							<div className="col-md-12">
								<div className="d-flex justify-content-around">
									<button className="button text">Button</button>
									<button className="button text">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button text">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button text">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button text">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button text">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button text">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12 mt-4">
								<div className="d-flex justify-content-around">
									<button className="button text" disabled>
										Button
									</button>
									<button className="button text" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button text" disabled>
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button text" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button text" disabled>
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button text" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button text" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<h5 className="mt-5">Approve 40px</h5>
								<p className="mb-3">
									Note: use <strong>.size36</strong> &amp; <strong>.size32</strong>
									class for diffrent size)
								</p>
							</div>
							<div className="col-md-12">
								<div className="d-flex justify-content-around">
									<button className="button approve">Button</button>
									<button className="button approve">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button approve">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button approve">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button approve">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button approved">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button approved">
										<span className="approved-text">Approved</span>
										<span className="bar mx-1">|</span>
										<span className="mr-1">Apr-26</span>
										<svg
											fill="none"
											height={13}
											viewBox="0 0 18 13"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M6.00109 10.1998L2.50109 6.69982C2.11109 6.30982 1.49109 6.30982 1.10109 6.69982C0.711094 7.08982 0.711094 7.70982 1.10109 8.09982L5.29109 12.2898C5.68109 12.6798 6.31109 12.6798 6.70109 12.2898L17.3011 1.69982C17.6911 1.30982 17.6911 0.689824 17.3011 0.299824C16.9111 -0.0901758 16.2911 -0.0901758 15.9011 0.299824L6.00109 10.1998Z"
												fill="#00C334"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12 mt-4">
								<div className="d-flex justify-content-around">
									<button className="button approve" disabled>
										Button
									</button>
									<button className="button approve" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button approve" disabled>
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button approve" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button approve" disabled>
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button approve" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<h5 className="mt-5">Revise 40px</h5>
								<p className="mb-3">
									Note: use <strong>.size36</strong> &amp; <strong>.size32</strong>
									class for diffrent size)
								</p>
							</div>
							<div className="col-md-12">
								<div className="d-flex justify-content-around">
									<button className="button revise">Button</button>
									<button className="button revise">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button revise">
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button revise">
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button revise">
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
							<div className="col-md-12 mt-4">
								<div className="d-flex justify-content-around">
									<button className="button revise" disabled>
										Button
									</button>
									<button className="button revise" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
									</button>
									<button className="button revise" disabled>
										<span className="mr-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button revise" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="mx-1">Button</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button revise" disabled>
										<span>Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
									<button className="button revise" disabled>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
										<span className="ml-1">Button</span>
										<span className="bar mx-1">|</span>
										<svg
											fill="none"
											height={24}
											viewBox="0 0 24 24"
											width={24}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
												fill="white"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	);
}
export default Buttons;
